module.exports = __webpack_public_path__ + "static/media/intro-bg.6f3c3029.svg";